/**
 * DFP Custom
 * global DFP_config, DFP_ad_units, DFP_custom_targeting
 */
var DFP = DFP || {};  
(function ( window, DFP, config, ad_slots, custom_targeting, googletag,$ ) {
    ad_slots = JSON.parse(ad_slots);

 //initialize Amazon A9
// !function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function(){q("f",arguments)},setDisplayBids:function(){},targetingKeys:function(){return[]},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(A,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");
// apstag.init({
//     pubID: '29eba328-6960-4aaa-a6e7-6878d8d7ed66',
//     adServer: 'googletag',
//     simplerGPT: true
// });


	// Early exit
	if ( ! config || ! ad_slots || ! custom_targeting ) {
		return false;
	}

	// Registry of ad slot instances
	DFP.defined_slots = {};
	DFP.inserted_slots = {};
	DFP.extra_ids = [];
	DFP.rendered = false; // Backup check

	/**
	 * On Resize
	 */
	var resize_timeout = null,
		resize_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
	;
	var onResize = function ( ) {
		var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if ( width === resize_width ) { 
			// Fake resize!
			return;
		}
		resize_width = width;

		// Debounce resize
		clearTimeout(resize_timeout);
		resize_timeout = setTimeout(DFP.refresh, 500);
	};
	if ( window.addEventListener ) {
		window.addEventListener('resize', onResize, false);
	} else {
		window.attachEvent('onresize', onResize);
	}

	/**
	 * On Load
	 */
	var onLoad = function ( ) {
		// Backup check to make sure ads rendered (they should have by now)
		if ( ! DFP.rendered ) {
                        // 05/14/2018 - This has been disabled because this variable seems still false
                        // after the Load giving a flickering on ads
                        // In addition, if slots are not filled, the code should be reviewed instead of refreshing the process
			//DFP.refresh();
		}
	};
	if ( window.addEventListener ) {
		window.addEventListener('load', onLoad, false);
	} else {
		window.attachEvent('onload', onLoad);
	}

	/**
	 * Process Slots
	 * @param object ad_slots Slots
	 */
	DFP.process = function ( ad_slots ) {
		
		var i, sizeMapping;

        for (var i in ad_slots) {

			if ( DFP.defined_slots[ad_slots[i].id] ) { continue; } // Don't define slots twice!!!
                        if($('#' + ad_slots[i].id).length){
                            // Define Slot
                            DFP.defined_slots[ad_slots[i].id] = DFP.defineSlot(config.account, ad_slots[i].name, ad_slots[i].sizes, ad_slots[i].id, ad_slots[i].sizeMapping, {
                                    outofpage: ad_slots[i].outofpage, 
                                    companion: ad_slots[i].companion
                            });

                            // Add size mapping, if applicable
//                            if ( ad_slots[i].sizeMapping && (sizeMapping = DFP.sizeMapping(ad_slots[i].sizeMapping)) ) {
//                                    DFP.defined_slots[ad_slots[i].id].defineSizeMapping(sizeMapping);
//                            }

                            // Reference to original ad slot
                            DFP.defined_slots[ad_slots[i].id].DFP_ad_slot = ad_slots[i];
                            
                        }
		}
	};

	/**
	 * Define Slot
	 * @param string account
	 * @param string name
	 * @param string|false sizes
	 * @param string id
	 * @param object options
	 * @return googletag.defineSlot
	 */
	DFP.defineSlot = function ( account, name, sizes, id, sizeMapping, options ) {
		var slot, mapping;
 
		// Out of page or regular slot?
		if ( options.outofpage ) {
			slot = googletag.defineOutOfPageSlot('/' + account + '/' + name, id);
		} else {
			slot = googletag.defineSlot('/' + account + '/' + name, JSON.parse(sizes), id);
		}
                
                // Add size mapping, if applicable
                if ( sizeMapping && (mapping = DFP.sizeMapping(sizeMapping)) ) {
                   slot.defineSizeMapping(mapping);
                }

		// Companion ad?
		if ( options.companion ) {
			slot = slot.addService(googletag.companionAds());
		}

		// Always add the pubads service
		return slot.addService(googletag.pubads());
	};

	/**
	 * Size Mapping
	 * @param object mapping
	 * @return googletag.sizeMapping
	 */
	DFP.sizeMapping = function ( mapping ) {
		if ( ! mapping ) { 
			return undefined;
		}

		var sizeMapping = googletag.sizeMapping(); // Create
		var screenSize;

		for ( screenSize in mapping ) {
			sizeMapping.addSize(JSON.parse(screenSize), JSON.parse(mapping[screenSize])); // Add Size
		}

		return sizeMapping.build(); // Build
	};

	DFP.renderEnded = function ( event ) {
		if ( ! event.slot.DFP_ad_slot ) { 
			// This wasn't a slot we defined!
			return;
		}

		// Don't force fill
		if ( event.isEmpty ) {
			return;
		}

		// Note that we are here
		DFP.rendered = true;

		// Extras
		if ( event.slot.DFP_ad_slot.extra ) {
			(function ( event, original_slot ) {
 				 
				// Search for size match
				var size;
				for ( size in original_slot.extra ) {
					if ( JSON.stringify(event.size) === JSON.stringify(JSON.parse(size)) ) {
						break;
					}
				}

				// If we don't have a match, exit
				if ( JSON.stringify(event.size) !== JSON.stringify(JSON.parse(size)) ) {
                                    $('.slot_extra_' + original_slot.id ).remove();
                                    return;
				}
				
				// Inject Ads
				var j, name;
				for ( j = 0; j < original_slot.extra[size].length; j++ ) {
                                    
                                        // Insert ad after our original slot
                                        var slot_name = original_slot.extra[size][j];
                                        var slot_id = 'DFP_slot_' + slot_name; 
                                        // Assumes that jQuery is already loaded
                                        if( ! $('#'+slot_id).length ){
                                            $('#' + original_slot.id).
                                                    closest( '.Ad.Widget' ).
                                                    after('<div class="Ad Widget slot_extra_' + original_slot.id + '"><div class="Ad-content"><div id="'+slot_id+'" ></div></div></div>');
                                        }
                                        
                                        googletag.cmd.push(function() {
                                                 var definedSlot = googletag.defineSlot('/' + config.account + '/' + slot_name , JSON.parse(size) , slot_id );
                                                 if( definedSlot ){
                                                    definedSlot.setCollapseEmptyDiv(true).
                                                    addService(googletag.pubads());                                                    
                                                    googletag.enableServices();
                                                    //googletag.display( slot_id );
                                                    
                                                    if ( original_slot.name === 'wtop_right_1' ) {
                                                        apstag.fetchBids({
                                                          slots:[{
                                                              slotID: slot_id,
                                                              sizes: JSON.parse(size),
                                                              slotName: '/' + config.account + '/' + slot_name
                                                            }],
                                                                timeout: 1e3
                                                            },
                                                            function(bids) {
                                                                // set apstag targeting on googletag, then trigger the first DFP request in googletag's disableInitialLoad integration 
                                                                apstag.setDisplayBids();
                                                                googletag.display( slot_id );
                                                        });
                                                    }
                                                    else{
                                                        googletag.display( slot_id ); 
                                                    }
                                                 }
                                        });
                                    
					// Display ad after our original slot
					//DFP.display(document.getElementById(original_slot.id), 'afterend', original_slot.extra[size][j]);
					
					// Add to list of divs to delete
					DFP.extra_ids.push(original_slot.extra[size][j]);
				}

			})(event, event.slot.DFP_ad_slot);
		}
                
                // expandable banner 
//                if ( event.slot.DFP_ad_slot.name === 'wtop_contracting_banner' ) {
//                    
//                    var banner_id = event.slot['DFP_ad_slot'].id;                          
//                    var div_selector = '#'+ banner_id + ' div';
//                    var frame_selector = div_selector + ' iframe';  
//                    var ad_size = event.size;
//                    // get the first one
//                    var ad_height = ad_size[1]; 
//
//                    var expanded_size = JSON.parse(event.slot['DFP_ad_slot'].expandedSize);
//                    // single array
//                    var big_height = expanded_size[1];
//
//                    var transition = event.slot['DFP_ad_slot'].transition;
//                    if( ! transition ){
//                        transition = 4;
//                    }
//
//                    // expand/contract the ad
//                    $( div_selector + ', ' + frame_selector ).animate({height: big_height + 'px'});
//
//                    $( frame_selector ).on('load',function(){
//                        setTimeout(function(){
//                                $( div_selector + ', ' + frame_selector ).animate({height: ad_height + 'px'});
//                        },(transition * 1000));
//                    });
//                }
//                if ( (event.slot.DFP_ad_slot.name === 'wtop_header_banner' ) && ($('#header_sticky_ad_clearfix').length!==0)) {			 
//                        var ad_size_sticky = event.size;
//                        var ad_height_sticky = ad_size_sticky[1]; 					 
//                                $('#header_sticky_ad_clearfix').css({'height':( (ad_height_sticky > 60 ? (ad_height_sticky + 40 ) : ad_height_sticky ) )+'px'});
//                                 if($('body').hasClass('logged-in')){
//                                     var adminbar_height = $('#wpadminbar').height();
//                                     $('#header_sticky_ad').css({'margin-top': adminbar_height + 'px' }); 
//                                 }
//
//
//
//                }
//                var slot = $('#' + event.slot['DFP_ad_slot'].id );
//                var $iframe = slot.find('iframe');
//                var is_flex = false;
//                if( $iframe.attr('width') == "1" && $iframe.attr('height') == "1" ){
//                    is_flex = true;
//                } 
//                if ( event.slot.DFP_ad_slot.name.indexOf('header_banner') !== -1 || is_flex ) {
//                    var slot = $('#' + event.slot['DFP_ad_slot'].id );
//                    var $iframe = $( event.slot.getHtml( ) );
//                    var $img = $iframe.find('img');
//                    var flex = $img.attr('data-flex');
//                    //console.log(event.slot);
//                    //console.log('flex: ' + flex );
//                    if ( typeof( flex ) != "undefined" ) {
//                        slot.attr('data-flex' , flex );
//                        slot.attr('data-max-width' , $img.attr('data-max-width') );
//                        slot.addClass('wtop-flex-banner');
//                        DFP.resizeFlexIframe( slot );                        
//                    }
//                }
			 
	};

	/**
	 * Display an ad slot
	 * @param DOM element reference element
	 * @param string position 'afterend', 'beforeend', 'afterstart', 'beforestart'
	 * @param string id ID of ad slot to insert
	 */
	DFP.display = function ( element, position, id ) {  
		// Build HTML for ad
		var ad = config.template.replace(/%id%/g, id),
			div = ad.replace(/^(.*)[<]script[^>]*[>].*[<]\/script[>](.*)$/, '$1$2'), // Get div
			js = ad.replace(/^.*[<]script[^>]*[>](.*)[<]\/script[>].*$/, '$1') // Get js
			script = document.createElement('script'); // Create script tag
	 
		
		// Inject div into the DOM
		element.insertAdjacentHTML(position, div);
		
		// Inject js into the script
		script.innerHTML = js;
		// Inject script into div
		document.getElementById(id).appendChild(script);
	}

	DFP.remove = function ( id ) {
		// Remove entire div                
		var div = document.getElementById(id);
                if ( div ) {
                    div.parentNode.removeChild(div);
                }
                delete DFP.inserted_slots[id];
	}

	/**
	 * Set Custom Targeting
	 * @param object custom_targeting Targeting
	 */
	DFP.setTargeting = function ( custom_targeting ) {
		// Custom Targeting
		for ( name in custom_targeting ) {
			if ( ! custom_targeting.hasOwnProperty(name) || custom_targeting[name] == null ) { continue; }

			if ( custom_targeting[name].length > 0 ) {
				googletag.pubads().setTargeting(name, custom_targeting[name]);
			} // Else ignore

		}
	}

	/**
	 * Refresh DFP Ads
	 */
	DFP.refresh = function ( ) {
		if ( ! googletag ) { return; }

		// Remove extra IDs
		var i, div;
		for ( i = 0; i < DFP.extra_ids.length; i++ ) {
			DFP.remove(DFP.extra_ids[i]);
		}
		// Reset extra IDs
		DFP.extra_ids = [];

		// Refresh list
		var slots = [];
//		for ( id in DFP.inserted_slots ) {
//			if ( ! DFP.inserted_slots.hasOwnProperty(id) ) { continue; }
//			if ( ! DFP.defined_slots.hasOwnProperty(id) ) { continue; }
//			// Add to list Refresh
//                        console.log('my ids: ' + id );
//                        if($('#' + id ).length){
//                            slots.push(DFP.defined_slots[id]);
//                        }
//		}
                // array of slodats id's
                var slots_to_refresh = ['DFP_slot_wtop_mobile_adhesion_1','DFP_slot_wtop_right_1_1'];
		for ( i = 0; i < slots_to_refresh.length ; i++ ) {
			//if ( ! DFP.inserted_slots.hasOwnProperty( ad_slots[i].id ) ) { continue; }
			if ( ! DFP.defined_slots.hasOwnProperty( slots_to_refresh[i] ) ) { continue; }
			// Add to list Refresh
                        if($('#' + slots_to_refresh[i] ).length){
                            slots.push(DFP.defined_slots[slots_to_refresh[i]]);
                        }
		}
                // this would prevent warning and possibly the reloading of undefined slots
                if( slots.length ) {
                    // Refresh
                    googletag.pubads().refresh( slots );
                }
	};
        
        DFP.resizeFlexAds = function() {
            $('.wtop-flex-banner').each( function(){
                DFP.resizeFlexIframe( $(this) );
            });
        };
        DFP.resizeFlexIframe = function( $slot ){
            //move to a function
            //console.log( $slot );
            var flex = $slot.attr('data-flex'); 
            var max_width = $slot.attr('data-max-width');
            var iframe = $slot.find('iframe');
            var sizes = flex.split('x');
            var ratio = sizes[1]/sizes[0];
            var wd = $slot.outerWidth();
            var scaleHt = $(window).width( ) * ratio ;
            iframe.css('width', '100%');  
            iframe.css('height', ( scaleHt ) + 'px');
            if( $slot.hasClass('wtop-flex-banner')){
                // targeting the header
                if( $('#header_sticky_ad').length ){
                    scaleHt = scaleHt + parseInt( $('#header_sticky_ad').css( 'padding-bottom' ) );
                }
                $('#header_sticky_ad_clearfix').css('height',( scaleHt ) + 'px');
            }
        };
        /*
         * create slot and fetch ad for header banner within this js file
         */
        /*
         * create slot and fetch ad for header banner within this js file
         */
        
        DFP.processA9 = function(slotId, sizes, account, slotName){
            apstag.fetchBids({
                slots:[{
                    slotID: slotId,
                    sizes: JSON.parse(sizes),
                    slotName: '/' + account + '/' + slotName
                  }],
                      timeout: 1e3
                  },
                  function(bids) {
                      // set apstag targeting on googletag, then trigger the first DFP request in googletag's disableInitialLoad integration 
                      apstag.setDisplayBids();
                      googletag.display( slotId );
              });
        };
        
        DFP.processNewAds = function(newAdSlot){  
            if(($('#' + newAdSlot.id).length) && (typeof DFP.defined_slots[newAdSlot.id]=="undefined")){
                // Define Slot 

                var definedSlot = DFP.defineSlot(config.account, newAdSlot.name, newAdSlot.sizes, newAdSlot.id, newAdSlot.sizeMapping, {
                        outofpage: newAdSlot.outofpage, 
                        companion: newAdSlot.companion
                });  
                if(newAdSlot.name=="wtop_header_banner"){
                    DFP.defined_slots[newAdSlot.id] = definedSlot;
                    DFP.defined_slots[newAdSlot.id].DFP_ad_slot = newAdSlot;
                }
                else{
                    googletag.cmd.push(function() {                      
                        if(definedSlot){                            
                           definedSlot.setCollapseEmptyDiv(true).
                           addService(googletag.pubads());                                                    
                           googletag.enableServices(); 
                           
                           DFP.processA9(newAdSlot.id, newAdSlot.sizes, config.account,newAdSlot.name)   
                           //googletag.display(newAdSlot.id);
                          
                       }
                    });
                }
                      
            }
        };
        
         DFP.cf_right3Ads = function(){
            var id = "DFP_slot_wtop_right_3_1";
            var slotName = "wtop_right_3";
            var slotSizes = "[300, 250]"; 
            var sizeMap = {"[768, 200]":"[300,250]","[0, 0]":"[]"};

            var newAdSlot ={"name":slotName, 
                "sizes":slotSizes, 
                "id":id, 
                "sizeMapping" :sizeMap,
                "extra" : false,
                "outofpage":false,
                "companion":false,
                "expandedSize":false
            };    
            DFP.processNewAds(newAdSlot);        
            
        };
        
        DFP.cf_right4Ads = function(isreturn){
            var id = "DFP_slot_wtop_right_4_1";
            var slotName = "wtop_right_4";
            var slotSizes = "[300, 250]"; 
            var sizeMap = {"[768, 200]":"[300,250]","[0, 0]":"[]"};

            var newAdSlot ={"name":slotName, 
                "sizes":slotSizes, 
                "id":id, 
                "sizeMapping" :sizeMap,
                "extra" : false,
                "outofpage":false,
                "companion":false,
                "expandedSize":false
            };  
            if(isreturn==true){
                return newAdSlot;
            }
            else{
                DFP.processNewAds(newAdSlot);        
            }
            
        };


        DFP.fixAmazonAdsProblem= function(){            
                if($("#header_sticky_ad_clearfix").css('display') != 'none' && $("#header_sticky_ad_clearfix").outerHeight() <= 20){                             
                    $('#header_sticky_ad_clearfix').css({'height':$("#DFP_slot_wtop_header_banner_1").outerHeight()+15+'px'});
                }           
        };
    
        DFP.hideAdsCloseButton= function(){
            $(".header_banner_close_btn").hide();
        };
    
        DFP.showAdsCloseButton= function(){	
            console.log('close btn using dfp')
            var get_button_margin = function(){
                var docwidth = document.getElementById("google_ads_iframe_/6585/wtop_header_banner_0").offsetWidth;			
                var marginleft = (($( window ).width() + docwidth) / 2)-10;
                return marginleft;
            }
    
            var handle_closebtn = function(){
                var adclosebtn = "<div class='header_banner_close_btn'>&times;</div>"
                $( "#header_sticky_ad" ).append(adclosebtn );
                $(".header_banner_close_btn").show(); 
                $(".header_banner_close_btn").css({
                    "margin-left":get_button_margin()+"px", 
                    "margin-top":"-10px;"
                });
    
    
                $(".header_banner_close_btn").on('click', function ( e ) { 
                    e.preventDefault();	
                    DFP.hideAdsCloseButton();
                    // $("#header_sticky_ad").slideUp("slow");	
                    // $('#header_sticky_ad_clearfix').slideUp("slow");	
                    $stickyDiv
                        .css({ position:'absolute',top:$scrollTopHeader})
                        .animate({top:0}, "slow", function() {
                                if(jQuery('body').hasClass('logged-in')){
                                   jQuery('#header_sticky_ad').css({'margin-top': 0 }); 
                                }
                        });
                    $stickyDiv.removeClass("header_sticky_ad_transparent");    
                    DFP.fixAmazonAdsProblem();	
                });
            } 

            handle_closebtn();
    
        };

	/**
	 * Init
	 * Process slots, set targeting, 
	 */
        $(document).ready( function(){
            googletag.cmd.push(function() {
                
                    //DFP.cf_right3Ads(); 
                    // Process ad slots (insert occurs onReady)
                    DFP.process(ad_slots);
                    // Set Custom Targeting
                    DFP.setTargeting(custom_targeting);

                    // add listener		 
//                    googletag.pubads().addEventListener('slotRenderEnded', DFP.renderEnded);
//                    googletag.pubads().addEventListener('slotRenderEnded', function(event){
//                         if((typeof(event.slot.DFP_ad_slot.name)!=="undefined")&&(event.slot.DFP_ad_slot.name==="wtop_header_banner")){
//                              $('#header_sticky_ad').css({'z-index': 98 });
//                              $('#header_sticky_ad').slideDown( "slow", function() {
//                                // Animation complete.
//                              });
//                              $("#header_sticky_ad_clearfix").slideDown( "fast", function() {
//                                // Animation complete.
//                              });                             
//                             
//                         }
//                    });
//                    googletag.pubads().addEventListener('impressionViewable', function(event) {						
//                             if((typeof(event.slot.DFP_ad_slot.name)!=="undefined")&&(event.slot.DFP_ad_slot.name==="wtop_header_banner")){                                    
//                                    var $depth_div = $("#stickydepth");
//                                    $depth_div.removeClass('stickydepth_notready').addClass('stickydepth_ready');		                                    
//                                    DFP.showAdsCloseButton();
//                            }		
//                    });
//                    // Init 
//                    googletag.pubads().collapseEmptyDivs();
//                    googletag.pubads().setCentering(true);
//                    googletag.pubads().enableSingleRequest();
//                    googletag.companionAds().setRefreshUnfilledSlots(true);
//                    googletag.enableServices();
//
//                     apstag.fetchBids({
//					     timeout: 1e3
//					 }, function(bids) {
//					     // set apstag targeting on googletag, then trigger the first DFP request in googletag's disableInitialLoad integration 
//					     apstag.setDisplayBids();
//					       // display the defined slots
//		                    for ( var i in ad_slots){
//		                        if( typeof DFP.defined_slots[ad_slots[i].id] !== 'undefined' ) {
//		                            googletag.display( ad_slots[i].id );
//		                        }
//		                    }
//					 });
            }); // End googletag.cmd.push
        }); // End of Document Ready

})(window, window.DFP, window.DFP_config || {}, window.DFP_ad_slots || {}, window.DFP_custom_targeting || {}, googletag,jQuery);